import { GridCellParams, GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';
import { AssessmentValue } from 'types/enums';
import { PatientTableItem } from 'types/types';

const getFilterParams = () => ({
  getApplyFilterFn: (filterItem: GridFilterItem) => {
    if (!filterItem.field || !filterItem.operator) {
      return null;
    }

    return (params: GridCellParams<PatientTableItem | undefined, string>) => {
      if (!filterItem.field || !filterItem.operator) {
        return null;
      }

      return params.value.includes(filterItem.operator);
    };
  },
});

export const getPatientAssessmentFilters = (): GridFilterOperator[] => {
  return Object.values(AssessmentValue).map((value) => ({
    label: value,
    value: value,
    ...getFilterParams(),
  }));
};
